import { Button } from "@tblabs/truffle";


export class AddToBasketButton extends Button
{
    constructor(onClick: () => void)
    {
        super("Dodaj do koszyka", onClick);

        this.Class("product__button product__button--compact")
            .Attribute("data-testid", "add-to-basket-btn");
    }
}
